import { Formik, Form } from 'formik';
import { FormSelector } from '../components/FormElements';
import Button from '../components/Elements/Button';
import { OptionModel } from '../../common/types/OptionModel';
import Filters from '../components/UserCustomerMatch/Filters';
import { useEffect, useRef, useState } from 'react';
import UserCustomerMatchTable from '../components/UserCustomerMatch/UserCustomerMatchTable';
import useGetUserName from '../../hooks/useGetUserName';
import FormObserver from '../components/FormElements/FormObserver';
import { ApiResponseType } from '../../common/api/apiHelper';
import commonNetwork from '../../common/api/commonNetwork';
import { toast } from 'react-toastify';
import { successMessages } from '../../constants/messages/successMessages';
import PageTitle from '../components/PageTitle';
import { pageTitleTexts } from '../../constants/texts/pageTitleTexts';
import { errorMessages } from '../../constants/messages/errorMessages';
import { buttonTexts } from '../../constants/texts/buttonTexts';
import { useNavigate, useParams } from 'react-router-dom';
import { getSelectedValueFromId } from '../../common/helpers/selectBoxHelper';
import { getNavigationUrl } from '../../common/helpers/navigationHelpers';
import { usePermissionCheck } from '../../hooks/usePermissionCheck';
import { UserOperationTypes } from '../../common/types/AuthorizationProps';
import { useSelector } from 'react-redux';

type UserCustomerDetailProp = {
  user: number;
}

const initialValues: UserCustomerDetailProp = {
  user: 0
};

const UserCustomerMatch = () => {

  usePermissionCheck(UserOperationTypes["Kullanıcı İşlemleri"], "Kullanıcı İşlemleri izni yok");
  let { userId }: any = useParams();

  const formFilterRef = useRef<HTMLDivElement | any>(null);
  const tableSelectedRows = useRef<any>(null);

  // useState's
  const [formValues, setFormValues] = useState<UserCustomerDetailProp>({
    user: 0
  })
  const [filtersIsOpen, setFiltersIsOpen] = useState(true);
  const [isSelectedUser, setIsSelectedUser] = useState<boolean>(false);
  const [userOptions, setUserOptions] = useState<OptionModel[]>([]);
  const [selectedUser, setSelectedUser] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);
  const [userLoading, setUserLoading] = useState<boolean>(false);
  const [showTable, setShowTable] = useState<boolean>(false);

  // Pagination için filtrede ve tabloda page ve pageSize eşitliğini korumak için
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [filterFormValues, setFilterFormValues] = useState(initialValues);

  const { customerList } = useSelector((state: any) => state.webCustomers);

  const navigate = useNavigate();

  //useEffect's
  useGetUserName(setUserOptions, setUserLoading);  

  useEffect(() => {
    if (userId > 0) {
      setFormValues({
        user: userId
      });
    }
  }, [userId])

  useEffect(() => {
    setSelectedUser(formValues.user);
    setShowTable(false);
  }, [formValues])

  useEffect(() => {
    onSelectedUser();
  }, [selectedUser]);

  function onSelectedUser() {
    tableSelectedRows.current.clearSelected();
    if (selectedUser) {
      setIsSelectedUser(true);
      setFiltersIsOpen(true);
      formFilterRef.current.resetForm();
    } else {
      setIsSelectedUser(false);
      formFilterRef.current.resetForm();
    }
  }

  const onUpdate = async (value: UserCustomerDetailProp) => {
    setFormValues({ ...formValues, ...value });
  }

  const onSubmit = async () => {
    const parameters = {
      customerIds: tableSelectedRows.current.getSelectedRows(),
      userId: selectedUser,
    };

    let isError = false;

    customerList?.forEach((item: any) => {
      parameters.customerIds.forEach((customerId: number) => {
        if (customerId === item.customerId && item.isMatchToSelectedUser === true) {
          isError = true;
        }
      });
    });

    if (parameters.customerIds.length >= 1) {
      if (!isError) {
        let result: ApiResponseType;

        result = await commonNetwork.post("/CustomerUser", parameters);

        if (result.isSuccess) {
          toast.success(successMessages.userMatched);
          tableSelectedRows.current.clearSelected();
          formFilterRef.current?.onSubmit();
          if (userId > 0) {
            navigate(getNavigationUrl("/kullanici-listesi"));
          }
        } else {
          toast.error(result.errorMessage);
        }
      } else {
        toast.error("Lütfen Bağlı Kullanıcı Durumu 'Atanmamış' olan bir müşteri seçiniz.");
      }
    } else {
      toast.error("Lütfen bir müşteri seçiniz.")
    }
  };


  const handleLoadingStatus = (loadingValue: boolean) => {
    setLoading(loadingValue);
  }

  async function handleRemoveConnection() {
    const parameters = {
      customerIds: tableSelectedRows.current.getSelectedRows(),
      userId: selectedUser
    }

    let isError = false;

    customerList?.forEach((item: any) => {
      parameters.customerIds.forEach((customerId: number) => {
        if (customerId === item.customerId && item.isMatchToSelectedUser === false) {
          isError = true;
        }
      });
    });

    if (parameters.customerIds.length >= 1) {
      if (!isError) {
        let result: ApiResponseType;
        try {
          result = await commonNetwork.post("CustomerUser/Remove", parameters);
          if (result.isSuccess) {
            toast.success(successMessages.connectionRemoved);
            tableSelectedRows.current.clearSelected();
            formFilterRef.current?.onSubmit();
            if (userId > 0) {
              navigate(getNavigationUrl("/kullanici-listesi"));
            }
          } else {
            toast.error(result.errorMessage);
          }
        } catch (error) {

        }
      } else {
        toast.error("Lütfen Bağlı Kullanıcı Durumu 'Atanmış' olan bir müşteri seçiniz.");
      }
    } else {
      toast.error("Lütfen bir müşteri seçiniz.")
    }
  }

  return (
    <div className='w-full'>
      <PageTitle title={pageTitleTexts.userCustomerMatch} />
      <div className='px-4 py-2 flex flex-col justify-start space-y-2'>
        <div className="flex flex-row items-center">
          <img src={"/icons/user-match.svg"} className="h-6 w-6 black" />
          <span className="text-lg font-bold leading-7 text-contrast-90 sm:truncate ml-2">
            Kullanıcı - Müşteri Yetkilendir
          </span>
        </div>
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
        >
          {() => {
            return (
              <Form className='w-full h-full'>
                <FormObserver watch={(val: any) => onUpdate(val)} />
                <div className="px-4 py-2 bg-white shadow-md pb-4 mt-1 rounded-md">
                  <div className=" grid grid-cols-1 gap-2 sm:gap-3 lg:grid-cols-3 xl:grid-cols-3">
                    <div className='mt-1'>
                      <FormSelector
                        options={userOptions}
                        name="user"
                        isDisabled={userId > 0 ? true : false}
                        placeholder="Kullancı seç"
                        label="Kullanıcı Seç"
                        isSearchable={true}
                        isClearable={true}
                        value={getSelectedValueFromId(formValues.user, userOptions)}
                        onChange={() => {
                        }}
                        isLazyFrontend
                        lazyPageSize={50}
                        loading={userLoading}
                      />
                    </div>
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
      <div className={`${!isSelectedUser ? "hidden" : ""}`}>
        <div className="pt-2 flex flex-row-reverse pr-3.5  space-x-3 space-x-reverse">
          <Button
            size="xs"
            hover="gray"
            color="gray"
            callback={() => setFiltersIsOpen(!filtersIsOpen)}
          >
            <span className="mr-3">{buttonTexts.filterOpen}</span>
            <img src="/icons/filter.svg" alt="filter" />
          </Button>
        </div>
        <div className=" flex flex-col justify-start space-y-2">
          <Filters
            ref={formFilterRef}
            isOpen={filtersIsOpen}
            setFiltersIsOpen={setFiltersIsOpen}
            selectedUser={selectedUser}
            tableSelectedRows={tableSelectedRows}
            loadingStatus={handleLoadingStatus}
            page={page}
            pageSize={pageSize}
            setFilterFormValues={setFilterFormValues}
            setShowTable={setShowTable}
          />
        </div>
        <div className="flex flex-row-reverse pr-3.5  space-x-3 space-x-reverse">
          <Button
            size="xs"
            hover="primary"
            color="primary"
            disabled={showTable ? false : true}
            callback={onSubmit}
          >
            <img src="/icons/connection-white.svg" alt="matchUser" />
            <span className='ml-3 mr-3'>Yetkilendir</span>
          </Button>
          <Button
            size="xs"
            hover="gray"
            color="gray"
            disabled={showTable ? false : true}
            callback={() => {
              handleRemoveConnection()
            }}
          >
            <img src="/icons/person-remove-primary.svg" alt="dismatchUser" />
            <span className='ml-3 mr-3'>Yetkiyi Kaldır</span>
          </Button>
        </div>
        <UserCustomerMatchTable
          formFilterRef={formFilterRef}
          tableSelectedRows={tableSelectedRows}
          selectedUser={selectedUser}
          showTable={showTable}
          page={page}
          pageSize={pageSize}
          setPage={setPage}
          setPageSize={setPageSize}
          filterFormValues={filterFormValues}
        />
      </div>
    </div>
  );
};

export default UserCustomerMatch;
